import * as React from 'react';
import { observer } from 'mobx-react';
import { IBenefitsRewardsTableHeader } from '~views/marketing-page/benefits-rewards/IBenefitsRewards';
import { LoyaltyTierDiamond } from '~views/LoyaltyTierDiamond';
import styled from 'styled-components';
import { classes } from '~utils/Classes';

const benefitsRewardsTableTableHeading2Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading2'
);
const benefitsRewardsTableTableHeading3Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading3'
);
const benefitsRewardsTableTableHeading4Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading4'
);
const benefitsRewardsTableLevelClass = 'loyalty-marketing-page-benefits-rewards__tableLevelHeader';

const BenefitsRewardsTableThWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const BenefitsRewardsTableHeading3 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading3;
`;

const BenefitsRewardsTableHeading4 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading4;
`;

const BenefitsRewardsTableTh = styled.th<{ backgroundColor: string }>`
    grid-area: benefitsRewardsTableTh;
`;

const BenefitsRewardsTableHeading2 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading2;
`;

const diamondSize = '10px';

export const BenefitsRewardsTableHeader = observer(function EarnPointsDetails({
    tier,
    levelName,
    shortDescription,
    heading,
    tierColor,
    textColor
}: IBenefitsRewardsTableHeader) {
    return (
        <BenefitsRewardsTableTh
            backgroundColor={tierColor.hex}
            className={benefitsRewardsTableLevelClass}
        >
            <BenefitsRewardsTableThWrapper>
                <LoyaltyTierDiamond
                    loyaltyTier={tier}
                    textColor={tierColor.hex}
                    size={diamondSize}
                    sign={''}
                />
                <BenefitsRewardsTableHeading2
                    textColor={textColor.hex}
                    className={benefitsRewardsTableTableHeading2Class}
                >
                    {heading}
                </BenefitsRewardsTableHeading2>
                <BenefitsRewardsTableHeading3
                    textColor={textColor.hex}
                    className={benefitsRewardsTableTableHeading3Class}
                >
                    {levelName}
                </BenefitsRewardsTableHeading3>
                <BenefitsRewardsTableHeading4
                    textColor={textColor.hex}
                    className={benefitsRewardsTableTableHeading4Class}
                >
                    {shortDescription}
                </BenefitsRewardsTableHeading4>
            </BenefitsRewardsTableThWrapper>
        </BenefitsRewardsTableTh>
    );
});
